import { Notification } from '@dtpk-cc/components';

export const RateLimitExceededError = () => (
    <Notification variant={Notification.Variant.alert} closable={false} noSideMargins noBottomMargin>
        <Notification.CopyText data-test-error="rate_limit_exceeded_error">
            Leider kann unser System die von Ihnen eingegebenen Daten nicht finden. <br />
            Beachten Sie bitte, dass nur 5 Versuche möglich sind. Danach wird ihr Zugang aus Gründen der Datensicherheit
            für 24 Stunden gesperrt.
        </Notification.CopyText>
    </Notification>
);
